import { useQuery } from "@apollo/client";
import { Navigate, useLocation, useParams } from "react-router-dom";

import { GET_FINDING_GROUP_AND_ORGANIZATION } from "./queries";

/**
 * This component queries the organization and group name and redirects accordingly.
 */
const FindingRedirect = (): JSX.Element => {
  const { pathname } = useLocation();
  const { findingId } = useParams<{
    findingId: string;
  }>();

  const { data } = useQuery(GET_FINDING_GROUP_AND_ORGANIZATION, {
    variables: { findingId: findingId ?? "" },
  });

  if (data?.finding) {
    const { groupName, organizationName } = data.finding;

    return (
      <Navigate
        to={`/orgs/${organizationName}/groups/${groupName}${pathname.replace(
          "/v/",
          "/vulns/",
        )}`}
      />
    );
  }

  return <div />;
};

export { FindingRedirect };
